import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showBreadcrumbsLogin } from '../../actions/show-breadrumbs-login';
import classNames from 'classnames';
import { IS_LOGIN_WIDGET_ENABLED_PATH } from '../../constants/wix-params';
import requestLogin from '../../actions/request-login';
import Button from '../../components/button';
import IconButton from '../../components/icon-button';
import { MemberIcon } from '../../components/icons';
import ProfileActionsButton from '../../components/profile-actions-button';
import UserAvatarImage from '../../components/user-avatar-image';
import NotificationButton from '../../components/notification-button';
import PrivateProfileActions from '../../containers/private-profile-actions';
import preventClickInDemoMode from '../../hoc/prevent-click-in-demo-mode';
import withAppSettings from '../../hoc/with-app-settings';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withAuth from '../../hoc/with-auth';
import withEnvironment from '../../hoc/with-environment';
import withTranslate from '../../hoc/with-translate';
import { isMemberAreaActive } from '../../selectors/member-area-selectors';
import styles from './breadcrumbs-widget.scss';

const ProtectedButton = preventClickInDemoMode(Button);

export class BreadcrumbsWidget extends Component {
  isLoginWidgetEnabled = () => {
    const { isLoginWidgetEnabled, isMemberAreaActive } = this.props;
    return isLoginWidgetEnabled !== undefined ? isLoginWidgetEnabled : !isMemberAreaActive;
  };

  renderLogin = () =>
    <div className={styles.container}>
      {this.renderSearchInput()}
      {this.renderMembersButton()}
      {this.renderLoginButton()}
    </div>;

  renderMainWidget = () =>
    <div className={styles.container}>
      {this.renderSearchInput()}
      {this.renderMembersButton()}
      {this.renderNotifications()}
      {this.renderProfile()}
    </div>;

  renderLoginButton = () => {
    const { requestLogin } = this.props;
    if (!this.isLoginWidgetEnabled()) {
      return null;
    }

    return (
      <ProtectedButton className={styles.loginButton} isSecondary onClick={requestLogin} data-hook="login-button">
        {this.props.t('header.sign-up-button')}
      </ProtectedButton>
    );
  };

  renderNotifications = () => {
    const { NotificationsLink } = this.props.navigation;
    return this.isLoginWidgetEnabled() ?
      <NotificationButton
        className={styles.notificationButton}
        component={NotificationsLink}
        iconClassName="breadcrumbs-icon-fill"
        bubbleClassName={classNames(
          'forum-header-border-color',
          'header-notification-bubble-background-color',
          'header-notification-bubble-text-color',
          styles.notificationBubble
        )}
        data-hook="notification-button"
      /> : null;
  };

  renderProfile = () => {
    const { currentUser } = this.props;

    if (!this.isLoginWidgetEnabled()) {
      return null;
    }

    const icon = (
      <button
        className={classNames(styles.avatarImage)}
        aria-label={this.props.t('breadcrumbs.profile')}
        data-hook="avatar-image"
      >
        <UserAvatarImage type="widget" user={this.props.currentUser}/>
      </button>
    );
    return (
      <div className={styles.profile}>
        <ProfileActionsButton
          actionsContainerClassName={styles.profileActions}
          position={ProfileActionsButton.POSITION_RIGHT}
          icon={icon}
        >
          <PrivateProfileActions user={currentUser}/>
        </ProfileActionsButton>
      </div>
    );
  };

  renderMembersButton = () => {
    const { MembersLink } = this.props.navigation;
    return this.isLoginWidgetEnabled() && !this.props.isMemberAreaActive ?
      <IconButton
        icon={MemberIcon}
        iconClassName="breadcrumbs-icon-fill members-icon-button"
        component={MembersLink}
        aria-label={this.props.t('breadcrumbs.members')}
        data-hook="members-button"
      /> : null;
  };

  renderSearchInput = () =>
    <div className={styles.searchInput} data-hook="search-input">
      {this.props.searchInput}
    </div>;

  render() {
    const { isAuthenticated, showLogin, viewMode } = this.props;

    const isEditor = viewMode && viewMode === 'editor';

    // For app settings toggling
    if (isEditor && showLogin) {
      return this.renderLogin();
    }

    if (!isAuthenticated) {
      return this.renderLogin();
    } else {
      return this.renderMainWidget();
    }
  }
}

BreadcrumbsWidget.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  showLogin: PropTypes.bool.isRequired,
  isOwner: PropTypes.bool.isRequired,
  isLoginWidgetEnabled: PropTypes.bool,
  requestLogin: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  viewMode: PropTypes.string.isRequired,
  showBreadcrumbsLogin: PropTypes.func.isRequired,
  searchInput: PropTypes.node,
  currentUser: PropTypes.object,
  navigation: PropTypes.object,
  isMemberAreaActive: PropTypes.bool,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    requestLogin,
    showBreadcrumbsLogin,
  }, dispatch);

const mapStateToProps = state => ({
  showLogin: state.breadcrumbsWidget.showLogin,
  viewMode: state.viewMode,
  isMemberAreaActive: isMemberAreaActive(state),
});

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withAppSettings({ isLoginWidgetEnabled: IS_LOGIN_WIDGET_ENABLED_PATH }),
  withAuth,
  withEnvironment({ navigation: 'navigation' }),
  withCardBackgroundColor,
  withTranslate
)(BreadcrumbsWidget);



// WEBPACK FOOTER //
// ./app/containers/breadcrumbs-widget/breadcrumbs-widget.js